import {useEffect, useState} from 'react';
import throwToast from '@/utils/ui/toast';
import globalDomains from '@/utils/global-domains';
import {sendClickLog} from '@/utils/main/my-plus/log';
import {sendLegacyInflowPathLog} from '@/utils/main/my/log';
import {setLocalStorage, getCookie, setCookie} from '@/utils/main';

import {objectToQueryString} from '@/utils';
import useModalControl from '@/components/soopi/hooks/useModalControl';
import {sendPostMessage} from '@/components/soopi/hooks/useSearchInpFocus';

const useSoopiHandler = (
  soopiTicket,
  isDragging,
  updateSoopiTicket,
  setHeight,
) => {
  const [iframeVisible, setIframeVisible] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [streamerProfile, setStreamerProfile] = useState('');
  const [dragPointStyle, setDragPointStyle] = useState('');

  const {
    handleClose: handlePreviewClose,
    handleChangeInfo: handleChangePreviewBroad,
    handleOpen: handlePreviewOpen,
    isOpen: previewOpen,
    info: previewBroadInfo,
  } = useModalControl();

  const {
    handleClose: handleLandingClose,
    handleOpen: handleLandingOpen,
    isOpen: LandingOpen,
  } = useModalControl();

  const openIframe = (url) => {
    setIframeUrl(url);
    setIframeVisible(true);
  };

  const closeIframe = () => {
    setIframeUrl('');
    setIframeVisible(false);
  };

  const handleOpenSoopi = (e) => {
    if (e.type === 'click' && !isDragging) {
      // 클릭 로그
      sendClickLog('soopi_front', {
        buttonType: 'soopi_icon',
      });
      openIframe(
        `${globalDomains.SOOPI_AFREECATV}?token=${soopiTicket?.token}&streamer_id=${soopiTicket?.persona?.streamerId}&has_chat_history=${soopiTicket?.hasChatHistory}`,
      );
    }
  };

  const handlePreviewControl = (broadUrl, broadType, streamerName, data) => {
    handleChangePreviewBroad({
      broadType,
      broadUrl,
      streamerName,
      data,
    });
    if (!previewOpen) {
      handlePreviewOpen();
    }
  };

  const sendPostMessage = () => {
    const message = JSON.stringify({
      type: 'subscription_popup_closed',
      value: soopiTicket,
    });
    const frame = document.getElementById('soopi-frame');
    if (frame?.contentWindow) {
      frame.contentWindow.postMessage(
        message,
        `${globalDomains.SOOPI_AFREECATV}`,
      );
    }
  };

  const openPopup = (data) => {
    const {url, target, features} = data;
    const popup = window.open(url, target, features);

    const timer = setInterval(() => {
      if (popup && popup.closed) {
        clearInterval(timer);
        sendPostMessage();
      }
    }, 500);
  };

  useEffect(() => {
    const messageLHandler = (event) => {
      if (event.origin !== `${globalDomains.SOOPI_AFREECATV}`) {
        return;
      }

      try {
        const {type, data} = JSON.parse(event.data);
        const {
          title_no = '',
          broad_no = '',
          streamer_id = '',
          streamer_nick = '',
          streamer_profile = '',
          streamer_video = '',
          size = '',
          url = '',
          inflow_path = '',
          contents_type = '',
          contents_value = '',
          is_autoplay = false,
          recommend_type = '',
          left = 0,
          width = 0,
          token = '',
        } = data || {};
        switch (type) {
          case 'CLOSE_WEBVIEW':
            closeIframe();
            break;
          case 'WATCH_VOD':
            // window.open(`${globalDomains.VOD_AFREECATV}/player/${title_no}`);
            handlePreviewControl(
              `${globalDomains.VOD_AFREECATV}/player/${title_no}`,
              'VOD',
              streamer_nick,
              data,
            );
            break;
          case 'WATCH_CATCH':
            handlePreviewControl(
              `${globalDomains.VOD_AFREECATV}/player/${title_no}`,
              'Catch',
              streamer_nick,
              data,
            );
            break;
          case 'WATCH_LIVE':
            handlePreviewControl(
              `${globalDomains.PLAY_AFREECATV}/${streamer_id}/${broad_no}`,
              'LIVE',
              streamer_nick,
              data,
            );
            break;
          case 'NAVIGATE_BROWSER':
            window.open(url);
            break;
          case 'THROW_TOAST':
            throwToast(data.msg);
            break;
          case 'UPDATE_TOKEN':
            updateSoopiTicket({...soopiTicket, token});
            break;
          case 'REMOVE_TOKEN':
            updateSoopiTicket({});
            throwToast(data.msg);
            break;
          case 'UPDATE_PERSONA':
            const newSoopiTicket = {
              ...soopiTicket,
              persona: {
                streamerId: streamer_id,
                streamerNick: streamer_nick,
                streamerProfile: streamer_profile,
                streamerVideo: streamer_video,
              },
            };
            setStreamerProfile(streamer_profile);
            updateSoopiTicket(newSoopiTicket);
            break;
          case 'SETTING_HEIGHT':
            const {height} = data;
            setHeight(
              height === 'default'
                ? Math.floor(window.innerHeight * 0.6)
                : height,
            );
            break;
          case 'CHANG_FLOATING_PERSONA_SIZE':
            updateSoopiTicket({...soopiTicket, icon: size});
            setLocalStorage('floating_persona_size', size);
            break;
          case 'SOOPI_PAGE_CHANGE':
            const dragPointStyle = {
              left,
              width,
            };
            setDragPointStyle(dragPointStyle);
            break;
          case 'OPEN_NEW_WEB_POPUP':
            openPopup(data);
            break;
        }
        if (!inflow_path) return;

        const path2Value = is_autoplay ? 'autoplay' : '';
        const logData = {
          path1: inflow_path,
          path2: path2Value,
          contents_type,
          contents_value,
          is_autoplay,
          recommend_type,
        };
        sendLegacyInflowPathLog({
          broadcastId: broad_no,
          streamerId: streamer_id,
          type: contents_type,
          isLogSendData: logData,
        });
        if (contents_type === 'vod') {
          const uuid = getCookie('_au');
          const middleValue = broad_no || streamer_id;
          const pathKey = `${uuid}_${middleValue}_${Date.now()}`;
          setCookie('VIN', objectToQueryString({...logData, pathKey}));
        }
      } catch (error) {
        console.error('Error parsing message:', error);
      }
    };

    window.addEventListener('message', messageLHandler);

    return () => {
      window.removeEventListener('message', messageLHandler);
    };
  }, [soopiTicket]);

  return {
    iframeUrl,
    iframeVisible,
    handleOpenSoopi,
    closeIframe,
    streamerProfile,
    previewBroadInfo,
    dragPointStyle,
    previewOpen,
    handlePreviewClose,
    LandingOpen,
    handleLandingOpen,
    handleLandingClose,
  };
};

export default useSoopiHandler;
